export default __webpack_public_path__ + "img/jeep-logo.07664151.png";